__turbopack_context__.v({
  "spin": "spinner-module-scss-module__VFwPQq__spin",
  "spinner": "spinner-module-scss-module__VFwPQq__spinner",
});
